import React from 'react';

import { Loader, Message } from 'semantic-ui-react';

import _get from 'lodash/get';
import { useSelector } from 'react-redux';

import ExternalAnchor from 'components/common/ExternalAnchor';
import useBranding from 'components/modules/foundation/hooks/use-branding';

import {
  ANALYTICS_NOT_AVAILABLE_MESSAGE,
  EMBED_TITLE,
  EMBED_FRAME_BORDER,
} from './WebsiteAnalytics.constants';
import useAnalytics from './WebsiteAnalytics.hooks';
import WebsiteAnalyticsActionBar from './components/WebsiteAnalyticsActionBar';

import './WebsiteAnalytics.scss';

const propTypes = {};

const defaultProps = [];

export default function WebsiteAnalytics() {
  const user = useSelector((state) => _get(state, 'user.core.value'));
  const websiteId = useSelector((state) => _get(state, 'website.core.value.id'));
  const domains = useSelector((state) => _get(state, 'website.domains.value', []));
  const stackStatus = useSelector((state) => _get(state, 'website.core.value.stack_status'));

  const { isGlammatic } = useBranding();

  const website = {
    id: websiteId,
    stackStatus,
    domains,
  };

  const { embedUrl, loaded, available, reason } = useAnalytics(website, user);

  if (!loaded) {
    return <Loader active inline="centered" />;
  }

  if (isGlammatic) {
    return (
      <Message
        header="Your Analytics Have a New Home!"
        content={
          <div>
            We&apos;ve moved analytics to our new app — now with a refreshed interface, improved
            user experience, and more data at your fingertips. This is a mobile-first experience
            available right on your phone for the best UX on the go!
            <br />
            <br />
            👉{' '}
            <ExternalAnchor href="https://glammatic.frontkb.com/en/articles/8064641">
              Learn how to install the app on your mobile device
            </ExternalAnchor>
            <br />
            👉{' '}
            <ExternalAnchor href="https://glammatic.frontkb.com/en/articles/8064705">
              Take a quick tour of the app&apos;s main features
            </ExternalAnchor>
            <br />
            <br />
            If you&apos;re having trouble signing in or installing the app, feel free to contact us
            at <ExternalAnchor href="mailto:help@glammatic.com">help@glammatic.com</ExternalAnchor>.
          </div>
        }
      />
    );
  }

  if (!available) {
    return <Message header={ANALYTICS_NOT_AVAILABLE_MESSAGE} content={reason} />;
  }

  return (
    <div className="website-analytics">
      <iframe title={EMBED_TITLE} src={embedUrl} frameBorder={EMBED_FRAME_BORDER} />
      <WebsiteAnalyticsActionBar show={loaded} />
    </div>
  );
}

WebsiteAnalytics.propTypes = propTypes;
WebsiteAnalytics.defaultProps = defaultProps;
